import { CardContent, Grid } from '@mui/material'
import { CardHeader, Typography } from '@mui/material'
import { Icon } from '@progress/kendo-react-common'
import moment from 'moment'
import React from 'react'
import { Card, CardBody } from 'reactstrap'
import { EmployeesStatus } from '../../../_helper/helper'
import { Btn } from '../../../AbstractElements'

const NewEmployeeDetails = ({ data = {}, approvalHandler, disabled=true }) => {
    return (
        <Card  >
            <CardBody>
                <Grid container spacing={2}>
                    <Grid item className="mx-1">
                        <div  >
                            <Typography className="text-14 font-semibold pl-2 pt-1 ">
                                <Icon className="m-r-5" name="user" />
                                <b>Name</b>
                                <span style={{ fontWeight: "normal" }}> :
                                    {` ${data?.LastName ? `${data.LastName || ''} ${(data?.FirstName || data?.MiddleName) ? ', ' : ''}` : ''} ${data?.FirstName || ''} ${data?.MiddleName || ''}`}
                                    {/* {data?.LastName   || ''}  {data?.FirstName + ' ' || ''} {data?.MiddleName + ' ' || ''}  */}
                                </span>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item className="mx-1">
                        <div  >

                            <Typography className="text-14 font-semibold pl-2 pt-1 ">
                                <Icon className="m-r-5" name="set-column-position" />
                                <b>Subscriber ID</b>
                                <span style={{ fontWeight: "normal" }}> : {data?.EmployeeID || ''} </span>
                            </Typography>
                        </div>
                    </Grid>
                    {/* <Grid item className="mx-1">
                        <div >
                            <Typography className="text-14 font-semibold pl-2 pt-1 ">
                                <Icon className="m-r-5" name="user" />
                                <b>First Name </b>
                                <span style={{ fontWeight: "normal" }}> : {data?.FirstName || ''}</span>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item className="mx-1">
                        <div  >
                            <Typography className="text-14 font-semibold pl-2 pt-1 ">
                                <Icon className="m-r-5" name="user" />
                                <b>Middle Name</b>
                                <span style={{ fontWeight: "normal" }}> : {data?.MiddleName || ''}</span>
                            </Typography>
                        </div>
                    </Grid> */}

                    <Grid item className="mx-1">
                        <div  >
                            <Typography className="text-14 font-semibold pl-2 pt-1 ">
                                <Icon className="m-r-5" name="calendar" />
                                <b>Date Of Birth </b>
                                <span style={{ fontWeight: "normal" }}> : {data?.DOB ? moment(data?.DOB).format('MM-DD-YYYY') : ''}</span>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item className="mx-1">
            <div  >
                <Typography className="text-14 font-semibold pl-2 pt-1 ">
                    <Icon className="m-r-5" name="circle" style={{fontSize:"18px"}}/>
                    <b>Status</b>
                    <span className="textempfweight"> :  {EmployeesStatus(data?.EmployeeType)}</span>
                </Typography>
            </div>
        </Grid>
            <Grid item sx={{ flexGrow: 1 }}>
                <div style={{
                    display : "flex",
                    flexDirection: "row-reverse",
                    alignItems:"center",
                    marginRight:"10px"
                }}>
                <Btn
                attrBtn={{
                  color: "primary",
                  onClick: (e) => {
                    e.stopPropagation();
                    // setOpen({ ...open, selectOpen: !open.selectOpen });
                    approvalHandler()
                  },
                  style: { marginLeft: "20px" },
                //   disabled:disabled
                }}
              >
                Review
              </Btn>
                </div>
            </Grid>
                </Grid>
            </CardBody>
        </Card>
    )
}

export default NewEmployeeDetails